import axios from "./index";

class my {
  //获取账户信息
  static getUserBase(params) {
    return axios.get("/business-account/account/detail", { params: params });
  }
  //获取资金流水
  static getAccountList(params) {
    return axios.get("/business-account/account/flow/list", { params: params });
  }
  //帐单汇总
  static getBillList(params) {
    return axios.get("/business-finance/distributor/bill/page/list", { params: params });
  }
  //帐单汇总明细
  static getBillDetail(params) {
    return axios.get("/business-finance/distributor/bill/detail/page/list", { params: params });
  }


  //线下票帐单汇总
  static getOfflineBillList(params) {
    return axios.get("/business-finance/electronic/distributor/bill/page/list", { params: params });
  }
  //线下票帐单汇总明细
  static getOfflineBillDetail(params) {
    return axios.get("/business-finance/electronic/distributor/bill/detail/page/list", { params: params });
  }


  //帐单明细导入
  static importBillDetail(params) {
    return axios.post(`/business-finance/distributor/bill/import/check`, params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  //确认帐单
  static confirmBill(id) {
    return axios.post(`/business-finance/distributor/bill/confirm/${id}`);
  }
  //删除自导入的明细
  static delBillDetail(importId) {
    return axios.post(`/business-finance/distributor/bill/del/${importId}`);
  }
  //充值明细
  static getrechargeDetail(params) {
    return axios.get("/business-finance/distributor/recharge/page/list", { params: params });
  }
  //查询余额
  static getBalance(params) {
    return axios.get("/business-finance/distributor/recharge/business/balance", { params: params });
  }
  //充值申请
  static createRecharge(params) {
    return axios.post("/business-finance/distributor/recharge/create", params);
  }
  //取消支付
  static cancelRecharge(id) {
    return axios.post(`/business-finance/distributor/recharge/cancel/${id}`);
  }
  //支付
  static payRecharge(params) {
    return axios.post(`/business-finance/distributor/recharge/go-pay`, params);
  }

  //获取用户列表
  static getUserList(params) {
    return axios.get("/business-account/passenger/page/list", { params: params });
  }

  static getUserListNopage(params) {
    return axios.get("/business-account/passenger/list", { params: params });
  }

  //新增用户
  static addUser(params) {
    return axios.post("/business-account/passenger/insert", params);
  }

  //编辑用户
  static editUser(params) {
    return axios.post("/business-account/passenger/update", params);
  }

  //用户详情
  static getUserDetail(id) {
    return axios.get(`/business-account/passenger/detail/${id}`);
  }

  //删除乘客
  static delUser(id) {
    return axios.post(`/business-account/passenger/del/${id}`);
  }
}

export default my;
